module.exports = __webpack_public_path__ + "img/trigo.fedb7ed7.svg";